import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseEntityService, CrudEndpoints } from '@gci/components/base-page/base-entity.service';
import { BaseFilter, defaultFilter } from '@gci/components/base-page/base.type';
import { Solution } from 'app/models/solution.type';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SolutionService extends BaseEntityService<Solution> {

    constructor(
        private _httpClient: HttpClient,
    ) { 

        const endpoints: CrudEndpoints = {
            list: 'solution-service/solution',
        }

        super(_httpClient, environment.apiBaseUrl, endpoints, 'SolutionService');
    }

    getSolution(filter?: Partial<BaseFilter>, forceRefresh: boolean = false) {

        const queryParams: Record<string,any> = {
            ...defaultFilter,
            ...filter,
        }

        return this.getListNewFormat(forceRefresh, queryParams);
    }
}
